import styled from "styled-components";
import { deviceQuery, size } from "../../../styles/mediaSizes";

export const Wrapper = styled.div`
    display: grid;
    padding: 1.4rem;
    width: 760px;
    max-width: 100%;
    background-color: ${(props) => props.theme.palette.common.background};
    align-items: center;
    align-self: center;
    margin-top: 5.5%;       
    border-radius: 10px;
    box-shadow: 0px 0px 20px ${(props) => props.theme.palette.card.boxShadow.primary};
    @media ${deviceQuery.mobileL} {
        // background-color: red;
        width: unset;
        margin: 1rem 1rem 4rem 1rem;
    }

    &>.row{
        height:100%;
    }
`

export const Pool = styled.div`
    grid-area: 1 / 1;
`

export const PoolLoading = styled.div`
    grid-area: 1 / 1;
    z-index: 100;
    height: 100%;
    border-radius: 10px;
    background-color: ${(props) => props.theme.palette.common.background}d1;
    &> span {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
    }
`

export const Box = styled.div`
    background-color: ${(props) => props.theme.palette.common.mainBackground};
    height: 100%;
    max-height:100%;
    border-radius: 10px;
    width: 100%;

    @media (max-width: 600px) {
        margin-top: 0px;
     }
`
